// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2m5kp","header":"ReportDetails_header__3nKd5","title":"ReportDetails_title__1bMH-","left":"ReportDetails_left__WfQHc"};